let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jYAjT")).then(() => parcelRequire('kAVkt'));